export const baseUrl = "https://sri-annai-glfunnel-backend-55665302086.asia-south1.run.app/api/v1";
export const productName = "GL Funnel";
export const clientCompanyName = "Sri Annai Enterprises";
export const spinWheelUrl ="https://househuntrewards.in";
export const glPageUrl = "https://crm.glpages.s3-website.ap-south-1.amazonaws.com"